import { Starter } from './starter';
import { Manager } from './manager';

const managerInstance = new Manager();

export { Starter, managerInstance };
